// @flow

import { connect } from 'react-redux';

import { toggleDrawMode, drawingFinished } from 'actions/drawOverlay';
import { setFitBounds } from 'actions/map';

import {
  dndOverlaySetIsDragging,
  dndOverlaySetDndState,
  dndOverlaySetButtonVisible,
} from 'actions/dndOverlay';

import DNDOverlay from './DNDOverlay';

const mapStateToProps = ({ browser, dndOverlay }) => ({
  ...dndOverlay,
  browser,
});

const mapDispatchToProps = {
  toggleDrawMode,
  drawingFinished,
  setFitBounds,

  dndOverlaySetIsDragging,
  dndOverlaySetDndState,
  dndOverlaySetButtonVisible,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DNDOverlay);



// WEBPACK FOOTER //
// ./components/DNDOverlay/index.js